/* eslint-disable @typescript-eslint/explicit-member-accessibility */
export class RefreshTokenResponse {
    public AccessToken: string;
    public RefreshToken: string | null;
  
    constructor(accessToken: string, refreshToken: string | null) {
      this.AccessToken = accessToken;
      this.RefreshToken = refreshToken;
    }
  }